<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="image-wrapper">
                        <img class="card-img-top" src="assets/church_image.jpg" alt="Card image cap">
                    </div>
                    <div class="card-body">
                        <div class="timeline-box">
                            <div class="timeline-inner">
                                <div style="display:inline-block;width:100%;overflow-y:hidden;
                                ">
                                    <ul class="timeline timeline-horizontal">
                                        <li class="timeline-item">
                                            <div class="timeline-badge primary"><i
                                                    class="glyphicon glyphicon-check"></i>
                                            </div>

                                        </li>
                                        <li class="timeline-item">
                                            <div class="timeline-badge primary"><i
                                                    class="glyphicon glyphicon-check"></i>
                                            </div>

                                        </li>
                                        <li class="timeline-item">
                                            <div class="timeline-badge primary"><i
                                                    class="glyphicon glyphicon-check"></i>
                                            </div>

                                        </li>
                                        <li class="timeline-item">
                                            <div class="timeline-badge primary"><i
                                                    class="glyphicon glyphicon-check"></i>
                                            </div>

                                        </li>
                                        <li class="timeline-item">
                                            <div class="timeline-badge primary"><i
                                                    class="glyphicon glyphicon-check"></i>
                                            </div>

                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div class="form-area">

                            <div class="form-group">
                                <label>Name of Ministry<span class="color">*</span></label>
                                <input type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>User Email<span class="color">*</span></label>
                                <input type="email" class="form-control">
                            </div>


                            <div class="form-group">
                                <label>Slogan<span class="color">*</span></label>
                                <input type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlSelect1">Choose Faith<span class="color">*</span></label>
                                <select class="form-control" id="exampleFormControlSelect1">
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Member of Association<span class="color">*</span></label>
                                <input type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Tax ID Number(EIN or 501c3)<span class="color">*</span></label>
                                <input type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Guidedstar Id</label>
                                <input type="text" class="form-control">
                            </div>

                            <div class="form-group">
                                <label>Brigde Id</label>
                                <input type="text" class="form-control">
                            </div>

                            <div class="form-group">
                                <label>Select Ministry Type</label>
                                <input type="text" class="form-control">
                            </div>

                            <button type="submit" class="btn btn-primary btn-lg btn-block">Next</button>

                        </div>


                    </div>




                </div>
            </div>





            <div class="col-md-3">
                <app-events [showheader]=true></app-events>
            </div>
        </div>
    </div>
</div>